import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeadersWithAuthorization as prepareHeaders } from '@/apis/headers';
import { RiskTimeline } from '@/apis/risks/types/risksApi';
import { risksTimelineFromApiAdapter } from '@/apis/risks/adapters/risksTimelineFromApiAdapter';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export interface RiskTimelineProps {
  empId: number;
  outageId?: number;
  months: number;
}

export const risksApi = createApi({
  reducerPath: 'risksApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL, prepareHeaders }),
  endpoints: (builder) => ({
    getMillwrightRiskTimelineByOutageId: builder.query<
      RiskTimeline,
      RiskTimelineProps
    >({
      query: ({ empId, outageId, months }) => ({
        url: '/risks/timeseries',
        params: {
          emp_id: empId,
          months,
          ...(outageId && { outage_id: outageId }),
        },
      }),
      transformResponse: risksTimelineFromApiAdapter,
    }),
  }),
});

export const { useGetMillwrightRiskTimelineByOutageIdQuery } = risksApi;
